export default __webpack_public_path__ + "static/media/11-100.b92601da.jpg";